module.exports = __webpack_public_path__ + "static/waterproof-mattress-protector-1-ow-5a0b4e0a0f13f8b8e841af660aaa1055.webp";